import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';

import styles from './BigList.style';

class BigList extends React.Component {
  renderEmpty() {
    const { emptyText, classes } = this.props;

    return <Typography className={classes.empty}>{emptyText}</Typography>;
  }

  renderList() {
    const { children, classes } = this.props;

    return <List className={classes.muiList}>{children}</List>;
  }

  renderLoading() {
    const { classes } = this.props;

    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  renderInner() {
    const { loading, children } = this.props;

    if (loading) {
      return this.renderLoading();
    } else if (!children.length) {
      return this.renderEmpty();
    } else {
      return this.renderList();
    }
  }

  render() {
    const { classes } = this.props;

    return <div className={classes.root}>{this.renderInner()}</div>;
  }
}

BigList.defaultProps = {
  emptyText: 'No items',
  loading: false,
};

class BigListItem extends React.Component {
  render() {
    const { classes, key, onClick } = this.props;

    return (
      <div className={classes.listItem} key={key} onClick={onClick}>
        <ListItem button className={classes.muiListItem}>
          <div className={classes.primary}>{this.props.primary}</div>

          {this.props.secondary && (
            <div className={classes.secondary}>{this.props.secondary}</div>
          )}

          <div className={classes.spacer} />

          <div className={classes.actions}>{this.props.actions}</div>
        </ListItem>
      </div>
    );
  }
}

const StyledBigList = withStyles(styles)(BigList);
const StyledBigListItem = withStyles(styles)(BigListItem);

export default StyledBigList;
export { StyledBigListItem as BigListItem };
